import { Component, Input, OnInit } from '@angular/core';
import { ImagesApiService } from '../../services/images-api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageDetailsModalComponent } from '../../modals/image-details/image-details.modal.component';

/**
 *
 * */
@Component({
  selector: 'campfire-image-feed',
  templateUrl: './image-feed.component.html',
  styleUrls: ['./image-feed.component.scss']
})
export class ImageFeedComponent implements OnInit {
  images: any[] = [];

  calculatedGrid: any[] = [];

  constructor(
    private imagesApi: ImagesApiService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    this.imagesApi.getLatest().subscribe(images => {
      this.images = images;
      this.calculatedGrid = this.imageGrid;
    });
  }

  get imageGrid(): any[] {
    const output = [];

    let largeCount = 0;

    for (let i = 0; i < this.images.length; i) {
      let imageCount = Math.ceil(Math.random() * 10);

      if (imageCount < 5) {
        imageCount = 1;
      } else {
        imageCount = 2;
        largeCount++;
      }

      // Periodically force smaller images to break the layout up a bit.
      if (largeCount === 3) {
        largeCount = 0;
        imageCount = 1;
      }

      const currentOutput = [];

      for (let j = 0; j < imageCount; j++) {
        if (this.images.length > (i + j)) {
          const image = this.images[i + j];
          currentOutput.push(image);
        }
      }

      i += imageCount; // Advance by number of images.

      output.push(currentOutput);
    }

    return output;
  }

  get leftColumnImages(): any[] {
    return this.calculatedGrid.slice(0, Math.ceil(this.calculatedGrid.length / 2));
  }

  get rightColumnImages(): any[] {
    return this.calculatedGrid.slice(Math.ceil(this.calculatedGrid.length / 2), this.calculatedGrid.length);
  }

  onImageClicked(image: any) {
    const modalRef = this.modalService.open(ImageDetailsModalComponent, {
      size: 'lg',
      centered: true,
      backdropClass: 'white-backdrop'
    });

    modalRef.componentInstance.image = image;
  }
}

